import {FC} from 'react'
import OffersList from '../../modules/offers/OffersList'

const OffersListPage: FC = () => (
  <>
    <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
      <div className="col-md-12 col-lg-12 mb-md-5 mb-xl-10">
        <OffersList />
      </div>
    </div>
  </>
)

export default OffersListPage
